import { useState } from "react";
import axios from "axios";
import { Bold } from "lucide-react";
import { API_ENDPOINTS } from '../util/apiEndpoints';

function UploadPage() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    const fileName = selectedFile.name.toLowerCase();

    if (!fileName.endsWith(".zip") && !fileName.endsWith(".rar")) {
      setError("Only ZIP or RAR files are allowed.");
      setFile(null);
      e.target.value = "";
      return;
    }

    setFile(selectedFile);
    setError("");
    setMessage("");
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select a ZIP or RAR file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      setError("");
      setMessage("");

      await axios.post(
        API_ENDPOINTS.UPLOAD,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      setMessage("File uploaded successfully. Please wait for 30 minutes to process..");
      setFile(null);
      document.getElementById("fileUpload").value = "";
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message ||
          "File upload failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2>Upload ZIP / RAR File</h2>

      {/* Hidden native input */}
      <input
        id="fileUpload"
        type="file"
        accept=".zip,.rar"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />

      {/* Custom file selector */}
      <label htmlFor="fileUpload" style={styles.customFileWrapper}>
        <span style={styles.fileText}>
          {file ? file.name : "Select ZIP / RAR file"}
        </span>
        <span style={styles.browseButton}>Browse</span>
      </label>

      {error && <p style={styles.error}>{error}</p>}
      {message && <p style={styles.success}>{message}</p>}

      <button
        onClick={handleUpload}
        disabled={loading}
        style={{
          ...styles.button,
          opacity: loading ? 0.7 : 1,
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Uploading..." : "Upload"}
      </button>
    </div>
  );
}

const styles = {
  container: {
    padding: "40px",
    maxWidth: "500px",
    margin: "125px auto",
    backgroundColor: "#FCF6F5",
    borderRadius: "20px",
    textAlign: "center",
  },

  customFileWrapper: {
    marginTop: "18px",
    padding: "10px 16px",
    border: "2px solid #18693c",
    borderRadius: "30px",
    backgroundColor: "#FCF6F5",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold", 
    cursor: "pointer",
    transition: "0.3s",
  },

  fileText: {
    fontSize: "14px",
    color: "#0e0a0a",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "70%",
  },

  browseButton: {
    backgroundColor: "#ff8c00",
    color: "#fff",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "13px",
  },

  button: {
    marginTop: "20px",
    padding: "12px 24px",
    backgroundColor: "#ff8c00",
    color: "#fff",
    fontWeight: "bold",
    border: "none",
    borderRadius: "10px",
    fontSize: "16px",
  },

  error: {
    marginTop: "10px",
    color: "red",
  },

  success: {
    marginTop: "10px",
    color: "green",
  },
};

export default UploadPage;
